import React from 'react';

import {
	type NavigationAuthConfig,
	getNavigationAuthConfig,
} from '~/config/navigationAuth';

/**
 * Hook providing navigation auth configuration (SSO vs standalone).
 *
 * Use this in navigation components instead of checking IsConductorClient directly.
 * Centralizes auth-related behavior for the new navigation.
 *
 * @returns NavigationAuthConfig with authType, showConductorLink, etc.
 */
function useNavigationAuthConfig(): NavigationAuthConfig {
	return React.useMemo(
		() => getNavigationAuthConfig(),
		[],
	);
}

export default useNavigationAuthConfig;
export type { NavigationAuthConfig };
